import { Tracer } from '@opentelemetry/api';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { Store } from 'redux';
import {
  Instrumentations,
  Match,
  NitroFetchInstrumentation,
  OpenTelemetryManager,
  OtlpHttpTraceExporter,
  SpanRegistrar,
} from '@trp-ta-nitro/otel-browser-js';
import { RootState } from './state/store';

let otelManager: OpenTelemetryManager;
let spanRegistrar: SpanRegistrar | undefined;
let tracer: Tracer;

function newOtelUrlProvider(reduxStore: Store<RootState>) {
  return () => {
    const appConfig = reduxStore.getState().appConfig;
    let environment = appConfig.environment;
    if (environment === 'sandbox') {
      environment = 'dev'; // there is no sandbox opentelemetry collector
    }
    // this is piggybacking on the swagger ui opentelemetry ingestion endpoint because this reference implementation
    // does not have a backend-for-frontend (BFF) which is typically be where such an endpoint would be hosted
    return `https://api.${environment}.awstrp.net/swagger-ui/v1/traces?apikey=${appConfig.apiKey}`;
  };
}

function newReferenceRestSpanProcessor(reduxStore: Store<RootState>) {
  const httpExporter = new OtlpHttpTraceExporter({
    urlProvider: newOtelUrlProvider(reduxStore),
  });
  return new BatchSpanProcessor(httpExporter);
}

export function appTracer(): Tracer {
  if (!tracer) {
    throw new Error('tracer unavailable, call initOpenTelemetry()');
  }
  return tracer;
}

export function globalSpanRegistrar(): SpanRegistrar {
  if (!spanRegistrar) {
    spanRegistrar = new SpanRegistrar();
  }
  return spanRegistrar;
}

export function initOpenTelemetry(reduxStore: Store<RootState>) {
  const appName = 'asset-transfer-ui';
  otelManager = new OpenTelemetryManager({
    serviceName: {
      appId: 'app02730',
      appName,
    },
  })
    .withoutInstrumentation(Instrumentations.Fetch)
    .withInstrumentation(
      () =>
        new NitroFetchInstrumentation({
          // enable traceparent for all outgoing fetches...
          propagateTraceHeaderCorsUrls: [/.+awstrp\.net.*/, /.+troweprice\.com.*/],
          // ...except those that disallow it via CORS
          propagateTraceHeaderCorsUrlsBlacklist: [
            Match.UrlPathEquals('/v0/ciam-public/me'),
            Match.UrlPathEquals(
              '/architecture-reference-implementations_echo-oauth-token/echo',
            ),
          ],
        }),
    )
    .withSpanProcessor(newReferenceRestSpanProcessor(reduxStore) as any)
    .start();

  tracer = otelManager.newTracer(appName);
}
